import { useMemo } from 'react';
import HomeRecentSearches from '@pages/Home/sections/HomeRecentSearches/HomeRecentSearches';
import HomeReportsAndNews from "@pages/Home/sections/HomeReportsAndNews/HomeReportsAndNews";
import HomeCategoryLens from "@pages/Home/sections/HomeCategoryLens/HomeCategoryLens";
import HomeBrandPerceptions from "@pages/Home/sections/HomeBrandPerceptions/HomeBrandPerceptions";
import HomeWorkspaceLayout from "@pages/Home/components/HomeWorkspaceLayout";
import HomeTrending from '../sections/HomeTrending/HomeTrending';

export const HOME_OPERATORS_SCROLLBAR_ID = 'HomeOperatorsScrollbar';

const OperatorsWorkspace = () => {
    const sections = useMemo(
        () => [
            {
                id: 'news-reports',
                title: 'News & Reports',
                testId: 'blockHomeOperatorsReports',
                Component: HomeReportsAndNews
            },
            {
                id: 'trending-now',
                title: "Trending Now",
                testId: 'blockHomeTrendingNow',
                Component: () => <HomeTrending showShortTable showTopPosts />
            },
            {
                id: 'category-lens',
                title: 'Category Lens',
                testId: 'blockHomeOperatorsCategoryLens',
                Component: () => <HomeCategoryLens nextSectionId="brand-perceptions"/>
            },
            {
                id: 'brand-perceptions',
                title: 'Brand Perceptions',
                testId: 'blockHomeOperatorsBrandPerceptions',
                Component: HomeBrandPerceptions
            },
            {
                id: 'recent-searches',
                title: 'Recent Searches',
                testId: 'blockHomeOperatorsRecentSearches',
                Component: HomeRecentSearches
            },
        ],
        []
    );

    return (
        <HomeWorkspaceLayout
            scrollbarId={HOME_OPERATORS_SCROLLBAR_ID}
            sections={sections}
        />
    );
};

export default OperatorsWorkspace;
